// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import { parseBoolean } from "@rpsc/XDL/Utilities";

export const xHasProductsWithInvalidPrice = (cart: Cart | undefined) =>
    cart?.cartLines?.some(
        cartLine =>
            parseBoolean(cartLine.properties?.["priceNotFound"]) ||
            (!cartLine.isPromotionItem &&
                !cartLine.quoteRequired &&
                !cartLine.allowZeroPricing &&
                cartLine.pricing?.unitNetPrice === 0 &&
                cartLine.pricing?.unitRegularPrice === 0),
    );
